const $ = jQuery.noConflict();
import ProductAddToCart from './productAddToCart';

'use strict';
const Product = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	ajaxFinished: false,
	variantInfo: {},

	/** @description Initialize */
	init: ()=> {
		Product.productAddonsPopup();
		Product.colorSelected();
		Product.colorDropdownChange();
		Product.colorSelectionChange();
		Product.videoSafariFallback();
	},

	/**
	 * @description Stylequide scrollbar
	 */
	productAddonsPopup: () => {
		$(document).ready(function() {

			// Patch updateText once: whenever any inquiry button updates, sync all others with the same SKU
			const _originalUpdateText = ProductAddToCart.updateText.bind(ProductAddToCart);
			ProductAddToCart.updateText = function(button, newText, productSku) {
				_originalUpdateText(button, newText, productSku);
				$('.js-add-to-inquiry[data-product_sku="' + productSku + '"]').each(function() {
					const $other = $(this);
					if (!$other.is(button)) {
						_originalUpdateText($other, newText, productSku);
						// Also rebind events on the synced button so +/- works
						if (ProductAddToCart.quantity[productSku] > 0) {
							ProductAddToCart.addQuantityEvents(productSku, $other);
						} else {
							ProductAddToCart.addToInquiryEvents(productSku, $other);
						}
					}
				});
			};

			$('.product-addons__box-zoom').click(function() {
				const parentBox = $(this).closest('.product-addons__box');
				const image = parentBox.find('.product-addons__box-image img').attr('src');
				const sku = parentBox.find('.product-addons__box-sku').text();
				const name = parentBox.find('.product-addons__box-title').text();
				const dimensions = parentBox.find('.product-addons__box-dimensions').text();
				const productUrl = parentBox.data('product-url') || '#';

				$('.product-addons__popup img').attr('src', image);
				$('.product-addons__popup-sku').text(sku);
				$('.product-addons__popup-name').text(name);
				$('.product-addons__popup-dimensions').text(dimensions);
				$('.product-addons__popup-view-product').attr('href', productUrl);

				// Clone the card's button (which always reflects latest state) into the popup
				const $cardBtn = parentBox.find('.product-addons__box-btn').first();
				const $clonedBtn = $cardBtn.clone(true, true);
				$('.product-addons__popup-btn-placeholder').empty().append($clonedBtn);

				// Re-bind so popup clone's handlers point to the cloned elements
				ProductAddToCart.addButtonListeners();

				$('.product-addons__popup').fadeIn();
			});

			function closePopup() {
				$('.product-addons__popup').fadeOut();
			}

			$('.product-addons__popup-close, .product-addons__popup').click(function(e) {
				if ($(e.target).is('.product-addons__popup, .product-addons__popup-close')) {
					closePopup();
				}
			});

			$('.product-addons__popup-close').on('click', function() {
				closePopup();
			});

			$(document).keydown(function(e) {
				if (e.key === 'Escape') {
					closePopup();
				}
			});
		});
	},

	colorSelected: function() {
		$('.option-color__color').on('click', function() {
			if ($(this).hasClass('is-selected')) {
				// $(this).removeClass('is-selected'); // If already selected, deselect it
			} else {
				const parentContainer = $(this).closest('.js-product-attrs-container').first();
				$(parentContainer).find('.option-color__color.is-selected').removeClass('is-selected'); // Remove from others
				$(this).addClass('is-selected'); // Select the clicked one
				const selectedValue = $(this).find('span').first().data('value');
				let $searchRoot = parentContainer;
				if (!$searchRoot.find('select').length) {
					$searchRoot = parentContainer.parent();
				}
				const select = $searchRoot.find('select option[value="' + selectedValue + '"]');
				select.prop('selected', true);
				$searchRoot.find('select').trigger('change');
			}
		});
	},

	colorDropdownChange: function() {
		// on select change
		$('.js-product-attr-option-color').change(function() {
			const selectedValue = $(this).val();
			const parentContainer = $(this).closest('.product-attrs__group').first();
			const spanElement = $(parentContainer)
				.find('.js-span-selection[data-value="' + selectedValue + '"]');
			if (spanElement) {
				if (!spanElement.parent().hasClass('is-selected')) {
					spanElement.parent().click();
				}
			}
		});
	},

	colorSelectionChange: function() {
		// on color click — permanent selection
		$('.js-filter-option').on('click', function() {
			// Cancel any pending hover revert
			$(this).off('mouseleave.selectPreview');

			const selectedSpan = $(this).find('.js-span-selection');
			if (selectedSpan.length) {
				const selectedValue = selectedSpan.data('value');
				const parentContainer = selectedSpan.closest('.js-product-attrs-container');
				if (parentContainer.length) {
					let relatedSelect = parentContainer.find('select.js-product-attr-option-color');
					if (!relatedSelect.length) {
						relatedSelect = parentContainer.parent().find('select.js-product-attr-option-color');
					}
					if (relatedSelect.length) {
						relatedSelect.val(selectedValue).trigger('change');
					}
				}
			}

			if (window.innerWidth < 769) {
				const attrsWrap = $('.js-product-attrs-wrap');
				if (attrsWrap.length) {
					setTimeout(function() {
						$('html, body').stop(true).animate({scrollTop: attrsWrap.offset().top}, 400);
					}, 50);
				}
			}
		});

		// on color hover — preview select, revert on mouseleave
		$('.js-filter-option').on('mouseenter', function() {
			const selectedSpan = $(this).find('.js-span-selection');
			if (selectedSpan.length) {
				const selectedValue = selectedSpan.data('value');
				const parentContainer = selectedSpan.closest('.js-product-attrs-container');
				if (parentContainer.length) {
					let relatedSelect = parentContainer.find('select.js-product-attr-option-color');
					if (!relatedSelect.length) {
						relatedSelect = parentContainer.parent().find('select.js-product-attr-option-color');
					}
					if (relatedSelect.length) {
						const prevVal = relatedSelect.val();
						relatedSelect.val(selectedValue);
						if (relatedSelect.hasClass('select2-hidden-accessible')) {
							relatedSelect.trigger('change.select2');
						}
						$(this).one('mouseleave.selectPreview', function() {
							relatedSelect.val(prevVal);
							if (relatedSelect.hasClass('select2-hidden-accessible')) {
								relatedSelect.trigger('change.select2');
							}
						});
					}
				}
			}
		});
	},

	videoSafariFallback: function() {
		window.onload = () => {
			const video = document.querySelector('.buffet-banner__right-video');
			if (video) {
				video.play().catch(() => {
					video.style.display = 'none';
				});
			}
		};
	},
};

export default Product;
